import { Route } from "@angular/router";
import { AuthGuard, AuthGuardPr } from 'uApp/guards/auth.guard';
import { StartGuard } from 'uApp/guards/start.guard';
import { UrlTokenGuard } from 'uApp/guards/url-token.guard';
import { StartDataGuard } from 'uApp/guards/startdata.guard';

export const APP_ROUTES: Route[] = [
  {
    path: 'home',
    loadComponent: () => import('uPages/home/home.page').then(m => m.HomePage)
  },
  {
    path: '',
    redirectTo: 'partner-form',
    pathMatch: 'full'
  },
  {
    path: 'partner-form',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/partner-form/partner-form.page').then(m => m.PartnerFormPage)
      },
      {
        path: 'partner-complete',
        loadComponent: () => import('uPages/partner-complete/partner-complete.page').then(m => m.PartnerCompletePage)
      }
    ]
  },
  // {
  //   path: 'catalog',
  //   canActivate: [AuthGuardPr, StartDataGuard],
  //   children: [
  //     {
  //       path: '',
  //       loadComponent: () => import('./pages/catalog/catalog.page').then(m => m.CatalogPage)
  //     }
  //   ]
  // },
  {
    path: 'page-not-found',
    loadComponent: () => import('./pages/page-not-found/page-not-found.page').then(m => m.PageNotFoundPage)
  },
  {
    path: 'error',
    loadComponent: () => import('./pages/error/error.page').then(m => m.ErrorPage)
  },
  // {
  //   path: 'start',
  //   canActivate: [StartGuard],
  //   loadComponent: () => import('./pages/start/start.page').then(m => m.StartPage)
  // },
  // {
  //   path: 'login',
  //   canActivate: [StartDataGuard],
  //   loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  // },
  // {
  //   path: 'identification',
  //   canActivate: [StartDataGuard],
  //   loadComponent: () => import('./pages/identification/identification.page').then(m => m.IdentificationPage)
  // },
  {
    path: '**',
    loadComponent: () => import('./pages/page-not-found/page-not-found.page').then(m => m.PageNotFoundPage)
  }
];
